import common from '../common';

export default class CameraController {
	constructor(player) {
		this._player = player;
		this._activated = true;
		this._camera = common.camera;
		this.overheadControls = null;
		this.sideControls = null;
		this.ready = false;

		this.init();
	}

	init() {
		this.overheadControls = new THREE.MapControls(this._camera, common.renderer.view);
		this.overheadControls.enableDamping = true;
		this.overheadControls.panSpeed = 0.5;
		this.overheadControls.dampingFactor = 0.25;
		this.overheadControls.minDistance = 6;
		this.overheadControls.maxDistance = 20;
		this.overheadControls.enableRotate = false;
		this.overheadControls.enableZoom = false;
		this.overheadControls.enabled = false;
		this.overheadControls.enableLimits = true;
		this.overheadControls.limitsX = new THREE.Vector2(common.levelSettings.camera_limits.xmin, common.levelSettings.camera_limits.xmax);
		this.overheadControls.limitsZ = new THREE.Vector2(common.levelSettings.camera_limits.zmin, common.levelSettings.camera_limits.zmax);

		this.sideControls = new THREE.MapControls(this._camera, common.renderer.view);
		this.sideControls.enableDamping = false;
		this.sideControls.dampingFactor = 0.25;
		this.sideControls.minDistance = 2;
		this.sideControls.maxDistance = 10;
		this.sideControls.enableZoom = false;
		this.sideControls.enableRotate = false;
		this.sideControls.enablePanVer = false;
		this.sideControls.enabled = true;
		this.sideControls.target.copy(this._player.mesh.position);
		this.sideControls.target.y += 2.6;
		this.sideControls.enableLimits = true;
		this.sideControls.limitsX = new THREE.Vector2(common.levelSettings.camera_limits.xmin, common.levelSettings.camera_limits.xmax);
	}

	dispose() {
		this.sideControls.dispose();
		this.sideControls = null;

		this.overheadControls.dispose();
		this.sideControls = null;
	}

	update() {
		if (!this.ready) {
			return;
		}

		if (this.overheadControls.enabled) {
			this.overheadControls.update();
		} else if (this.sideControls.enabled) {
			this.sideControls.update();
		}
	}
}
